import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const documentSeriesURL = `api/v1/core-app/document-series`;

//obtaining the paginated data
export const getDocumentSeries = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${documentSeriesURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllDocumentSeries = () => axiosInstance.get(`${documentSeriesURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageDocumentSeries = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${documentSeriesURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getDocumentSeriesById = (id) => axiosInstance.get(`${documentSeriesURL}/retrieve/${id}`);

//creating function
export const createDocumentSeries = (body) => axiosInstance.post(`${documentSeriesURL}/create`, body);
//updating function
export const updateDocumentSeries = (id, body) => axiosInstance.patch(`${documentSeriesURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${documentSeriesURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataDocumentSeriesName = (e, cancelToken) =>
  axiosInstance.get(`${documentSeriesURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
